const _ = require('lodash')

export const entities = [
    {
        name: 'Contacts',
        fields: [
            {path: 'firstname', encrypted: true},
            {path: 'lastname', encrypted: true},
            {path: 'mail', encrypted: true, unique: true},
            {type: 'Function'},
            {path: 'phone', encrypted: true},
            {
                path: 'images', type: 'Image', link: {type: 'OTM', deleteType: 'cascade'},
                ps: {object: [function(images) {
                    // Once an image is persisted, none of its properties (name, date,
                    // user) are client-editable through this field: only adding a
                    // brand new image or removing an existing one (replacing the
                    // contact's photo) is a real feature. So every image carrying a
                    // known id is replaced wholesale by its stored version; dropped
                    // ids are not re-appended, since removal is legitimate here.
                    if(! this.options.$v) return images; // not the authoritative save pass
                    const fieldPath = this.norm && this.norm.path;
                    const oldImages = fieldPath && _.get(this.options.context, ["businessOldObject", fieldPath]);
                    if(! _.isArray(oldImages) || ! oldImages.length) return images;
                    const oldById = _.keyBy(oldImages.filter(i => i && i.id), "id");
                    return (_.isArray(images) ? images : []).map(i => (i && i.id && oldById[i.id]) ? oldById[i.id] : i);
                }]}
            },
            {path: 'comment'},
        ]
    }
]

export const administratorModule = {
    object: 'Contacts',
    name: 'administratorContactsModule',
    tKey: 'mTitle_contact',
    defaultSortBy: 'lastname',
    objectIdentifier: 'lastname',
    protectedExport: true,
    defaultSortDirection: 'ASC',
    category: {
        path: 'administrator',
        icon: 'admin'
    },
    viewMap: {
        dt: [
            {path: 'lastname'},
            {path: 'firstname',},
            {path: 'function'},
            {path: 'phone'},
            {path: 'mail'}
        ],
        form: [
            {path: 'lastname', required: true},
            {path: 'firstname', required: true},
            {path: 'function', required: true},
            {path: 'phone', required: true, type: 'phoneNumber'},
            {path: 'mail', required: true, emailAddress: true},
            {path: 'comment', type: 'richTextEditor'},
            {path: 'images', tKey: 'photo', placeholder: 'addPhoto', type: 'logoPicker', fieldPath: ['id', 'name', 'user.id', 'user.name', 'date'], required: true, singleImage: true}
        ]
    }
}

export const userModule = {
    object: 'Contacts',
    name: 'userContactsModule',
    tKey: 'mTitle_contacts',
    defaultSortBy: 'lastname',
    protectedExport: true,
    displayLog: false,
    defaultSortDirection: 'ASC',
    newable: false,
    removable: false,
    defaultFormButtons: [{
        tKey: 'return',
        bsStyle: 'default',
        type: 'return'
    }],
    category: {
        path: 'myBinder',
        icon: 'userBook'
    },
    viewMap: {
        dt: [
            {path: 'lastname'},
            {path: 'firstname'},
            {path: 'function'},
            {path: 'phone'},
            {path: 'mail'},
        ],
        form: [
            {tKey: 'photo', path: 'images', type: 'image', fieldPath: ['id', 'name', 'user.id', 'user.name', 'date'], editable: false, width: 200, hideLabel: true, noThumbnail: true},
            {path: 'lastname', editable: false, disabled: true},
            {path: 'firstname', editable: false},
            {path: 'function', editable: false},
            {path: 'phone', editable: false, type: 'phoneNumber'},
            {path: 'mail', editable: false}
        ]
    }
}
